/** Tooltip: a dark tag on hover (after the provider's delay) or keyboard focus. Wraps one focusable child. */
import type { ComponentProps, ReactElement, ReactNode } from "react";
import { Tooltip as Primitive } from "radix-ui";

export function TooltipProvider({ delayDuration = 250, ...props }: ComponentProps<typeof Primitive.Provider>) {
  return <Primitive.Provider delayDuration={delayDuration} {...props} />;
}

interface TooltipProps {
  content: ReactNode;
  side?: ComponentProps<typeof Primitive.Content>["side"];
  children: ReactElement;
  /** Controlled: for a trigger whose focus is its parent's (a toggle item's label). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function Tooltip({ content, side, children, open, onOpenChange }: TooltipProps) {
  return (
    <Primitive.Root open={open} onOpenChange={onOpenChange}>
      <Primitive.Trigger asChild>{children}</Primitive.Trigger>
      <Primitive.Portal>
        <Primitive.Content
          data-slot="tooltip-content"
          side={side}
          sideOffset={6}
          className="z-50 max-w-80 rounded-md bg-primary px-2.5 py-1.5 text-meta font-medium text-primary-foreground data-[state=delayed-open]:animate-tooltip-in"
        >
          {content}
        </Primitive.Content>
      </Primitive.Portal>
    </Primitive.Root>
  );
}
